module.exports = __webpack_public_path__ + "7f709e7fb65134e125ac6179e188e239.svg";